module.exports = __webpack_public_path__ + "img/黄藤.b0194fa1.jpg";